import sal from 'sal.js';
import setParallax from './parallax';
import setTheming from './theming';
import setScrolling from './scrolling';
import setHeader from './header';
import setBooking from './booking';
import setCookieConsent from './cookieconsent';
import setRelated from './related';
import setSmoothScroll from './smoothscroll';
import setAnchors from './anchors';
import setSplash from './splash';
import setNavigation from './navigation';

document.addEventListener('DOMContentLoaded', () => {
    sal({
        // SAL checks `intersectionRatio >= threshold`, so a literal 0 is
        // always true (ratios can't go negative) — every element fires
        // immediately on load regardless of position. A tiny positive
        // value still means "as soon as it touches the shrunk root" below,
        // without that always-true trap.
        rootMargin: '0px 0px -20% 0px',
        threshold: 0.01,
        once: true,
    });

    // The rootMargin above intentionally shrinks the trigger zone so
    // scroll-triggered reveals fire near the bottom of the viewport rather
    // than the moment an element is technically on screen. But that same
    // shrink applies to the very first check too — anything already sitting
    // in the initial viewport at load (no scroll needed) would otherwise
    // stay invisible until the user nudges the page. Reveal those up front,
    // against the real viewport, so only content below the fold gets the
    // scroll-linked treatment.
    document.querySelectorAll('[data-sal]').forEach((el) => {
        if (el.getBoundingClientRect().top < window.innerHeight) {
            el.classList.add('sal-animate');
        }
    });

    setSmoothScroll();
    setSplash();
    setTheming();
    setScrolling();
    setHeader();
    setBooking();
    setCookieConsent();
    setRelated();
    setAnchors();
    setParallax();
    setNavigation();
});
